module.exports = {
    validateStatus(response){
        return new Promise((resolve, reject) => {
            if(response.status === 200) resolve(response.json());
            let errorLogin = {
                estado: 'error',
                mensaje: 'usuario o código invalidos'
            }
            reject(errorLogin);
        });
    },
}